"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContent = void 0;
var getContent = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var url, response;
    var fetch = _b.fetch, templateUrl = _b.url, locale = _b.locale, jurisdiction = _b.jurisdiction, market = _b.market, vertical = _b.vertical;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                url = Object.entries({
                    '{{locale}}': locale,
                    '{{jurisdiction}}': jurisdiction,
                    '{{vertical}}': vertical,
                    '{{market}}': market,
                }).reduce(function (acc, _a) {
                    var _b = __read(_a, 2), placeholder = _b[0], value = _b[1];
                    return acc.replace(placeholder, value);
                }, templateUrl);
                return [4 /*yield*/, fetch(url, { method: 'GET' })];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response.json()];
        }
    });
}); };
exports.getContent = getContent;
//# sourceMappingURL=data:application/json;base64,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